export default {
  methods: {
    // 上移楼层
    upFloor(index) {
      if (index == 0) {
        return;
      }
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      const temp = list[index];
      list[index] = list[index - 1];
      list[index - 1] = temp;
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setFloorList", list);
      // 更新当前选中楼层的index
      this.$emit("selectFloor", {
        id: this.item.id,
        index: index - 1,
        key: this.item.key,
      });
    },
    // 下移楼层
    downFloor(index) {
      if (index == this.floorCount - 1) {
        return;
      }
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      const temp = list[index];
      list[index] = list[index + 1];
      list[index + 1] = temp;
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setFloorList", list);
      // 更新当前选中楼层的index
      this.$emit("selectFloor", {
        id: this.item.id,
        index: index + 1,
        key: this.item.key,
      });
    },
    // 删除楼层
    delFloor(index) {
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      list.splice(index, 1);
      this.$emit("selectFloor", {
        id: 0,
        index: -1,
        key: 0,
      });
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setFloorList", list);
    },
  },
};
